export default {"src":"/_next/static/media/tdesign_task.7cbcc9a1.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};